<div class="campo-anexo-container">

  <div *ngIf="anexo" class="arquivo-anexado d-flex align-items-center">
    <div class="arquivo-info-container d-flex align-items-center">
      <i class="fas fa-paperclip me-2 text-muted flex-shrink-0" style="font-size: 16px;"></i>
      
      <span class="arquivo-texto">
        {{ anexo.nome_original }} ({{ formatBytes(anexo.tamanho_bytes) }})
      </span>
      
      <i 
        *ngIf="anexo"
        class="fas fa-eye text-muted ms-2 flex-shrink-0 icon-hover" 
        style="font-size: 16px; cursor: pointer !important;"
        (click)="viewFile()"
        [attr.ngbTooltip]="showTooltip ? ('Visualizar arquivo' | translate) : null"
        container="body">
      </i>
    </div>
    
    <i 
      *ngIf="!desabilitado"
      class="fas fa-trash text-danger ms-2 flex-shrink-0 icon-hover" 
      style="font-size: 16px; cursor: pointer !important;"
      (click)="deleteAnexo()"
      [attr.ngbTooltip]="showTooltip ? ('Excluir arquivo' | translate) : null"
      container="body">
    </i>
  </div>

  <div *ngIf="!anexo" class="upload-area">
    <div 
      class="upload-zone d-flex align-items-center p-2"
      [ngClass]="{
        'border-danger': obrigatorio && !anexo && mostrarErro,
        'bg-secondary': desabilitado,
        'uploading': uploading
      }"
      (click)="!desabilitado && !uploading && fileInput.click()"
    >
      <i class="fas fa-paperclip me-2"></i>
      
      <div class="flex-grow-1">
        <span 
          class="upload-text"
          *ngIf="!uploading && !desabilitado"
        >
          Clique para selecionar arquivo
        </span>
        <span *ngIf="uploading">
          <i class="fas fa-spinner fa-spin me-1"></i>
          Enviando...
        </span>
        <span *ngIf="desabilitado && !uploading">Clique para selecionar arquivo</span>
      </div>
    </div>

    <input 
      #fileInput
      type="file" 
      class="d-none"
      [accept]="EXTENSOES_PERMITIDAS.join(',')"
      (change)="onFileSelected($event)"
      [disabled]="desabilitado || uploading"
    />
  </div>

  <div *ngIf="obrigatorio && !anexo && mostrarErro" class="invalid-feedback d-block mt-1">
    <small class="text-danger">
      <i class="fas fa-exclamation-triangle me-1"></i>
      Este campo é obrigatório
    </small>
  </div>
</div>